import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-f0c6dcbe"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "company-introduction"
};
const _hoisted_2 = {
  class: "text-center pb-80"
};
const _hoisted_3 = {
  class: "enterprise-spirit relative"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "bg"
}, null, -1));
const _hoisted_5 = {
  class: "enterprise-spirit-text"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Headernav = _resolveComponent("Headernav");
  const _component_Banner = _resolveComponent("Banner");
  const _component_ProductsList = _resolveComponent("ProductsList");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_Headernav), _createElementVNode("div", _hoisted_1, [_createElementVNode("h2", null, _toDisplayString(_ctx.$t("home.companyIntroduction.title")), 1), _createElementVNode("p", null, _toDisplayString(_ctx.$t("home.companyIntroduction.content")), 1), _createElementVNode("button", {
    onClick: _cache[0] || (_cache[0] = $event => $options.toRouter('jiuling'))
  }, _toDisplayString(_ctx.$t("home.button.about")), 1)]), _createVNode(_component_Banner), _createVNode(_component_ProductsList, {
    class: "container pt-80"
  }), _createElementVNode("div", _hoisted_2, [_createElementVNode("button", {
    onClick: _cache[1] || (_cache[1] = $event => $options.toRouter('products'))
  }, _toDisplayString(_ctx.$t("home.button.product")), 1)]), _createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createElementVNode("h2", null, _toDisplayString(_ctx.$t("home.enterpriseSpirit.title1")), 1), _createElementVNode("h3", null, _toDisplayString(_ctx.$t("home.enterpriseSpirit.title2")), 1), _createElementVNode("p", null, _toDisplayString(_ctx.$t("home.enterpriseSpirit.content")), 1), _createElementVNode("button", {
    class: "button-white",
    onClick: _cache[2] || (_cache[2] = $event => $options.toRouter('contact'))
  }, _toDisplayString(_ctx.$t("home.button.contact")), 1)])])]);
}